export const SectionHeading = ({ eyebrow, title, description, align = 'left' }) => (
  <div className={['grid gap-3', align === 'center' ? 'text-center' : 'text-left'].join(' ')}>
    {eyebrow ? <div className="text-xs font-semibold uppercase tracking-[0.2em] text-primary/80">{eyebrow}</div> : null}
    <h2 className="text-3xl font-semibold leading-tight sm:text-4xl">{title}</h2>
    {description ? <p className="max-w-2xl text-sm leading-relaxed text-base-content/70">{description}</p> : null}
  </div>
);
